export default __webpack_public_path__ + "static/Personas-5389f56f57f84600e1fc2c8152f1b822.png";